import {Routes} from '@/navigation/Routes';
import {
  ProgressBarSteps,
  ConsultationStatus,
  ConsultationType,
  SortOption,
  StatusBadgeVariant,
  HelpRequestStatus,
  HelpRequestUserType,
  HospitalType,
  HospitalSpecialistOnboardingStatus,
  PatientAccountTicketRequestStatus,
  PatientAccountTicketType,
  SpecialistOnboardingStatus,
  UploadAdditionalFilesProgressBarSteps,
  ResourceType,
  ActionType,
  UserRole,
  AdminRole,
  HospitalSpecialistAssignmentStatus,
  SpecialistProfileStatus,
} from './enums';
import {SelectInputitem} from '@/interface';

/**
 * isolated constants
 */
export const toastDuration = 10;
export const resetOtpTimer = 45;
export const NA = 'N/A';
export const BULLET = '• ';
export const paymentSuccessTimer = 5;
export const preSignupFilesExpiry = 1000 * 60 * 60 * 24; // 1 day
export const debounceTimer = 300; // milli secons
export const defaultDeadlineHours = 48;
export const supportedExtentions = ['.png', '.jpeg', '.jpg', '.pdf', '.docx', '.doc'];
export const defaultCountryId = 76; // india;
export const autoLogoutErrorCodes = [
  'E-10018', // Unauthorized Access
  'E-10019', // Token Expired
  'E-10120', // User Not Found
  'E-10179', // User Deleted
] as const;
export const ProfanityMessage = 'Your message contains language that is not permitted. Please try again.';

export const maxImageSize = 5 * 1024 * 1024; // 5MB
/**
 * Images
 */
export const Images = {
  // landing page
  logo_transparent: require('@/assets/images/logo_transparent.png'),
  footer_image_1: require('@/assets/images/landing-page/footer_img1.png'),
  footer_image_2: require('@/assets/images/landing-page/footer_img2.png'),
  bg_banner: require('@/assets/images/landing-page/bg-banner.png'),
  bg_hero: require('@/assets/images/landing-page/bg-hero.png'),
  doctor_1: require('@/assets/images/landing-page/doctor_1.png'),
  doctor_2: require('@/assets/images/landing-page/doctor_2.png'),
  doctor_3: require('@/assets/images/landing-page/doctor_3.png'),
  doctor_4: require('@/assets/images/landing-page/doctor_4.png'),
  doctor_5: require('@/assets/images/doc_5.png'),
  doctor_6: require('@/assets/images/doc_6.png'),
  doctor_7: require('@/assets/images/doc_7.png'),
  doctor_8: require('@/assets/images/doc_8.png'),
  doctor_9: require('@/assets/images/doc_9.png'),
  second_opinion: require('@/assets/images/landing-page/second-opinoin.png'),
  hippa_complaince: require('@/assets/images/landing-page/hippa.png'),
  end_to_end_encryption: require('@/assets/images/landing-page/encryption.png'),
  board_certified: require('@/assets/images/landing-page/board_certified.png'),
  patients_trusted: require('@/assets/images/landing-page/patients.png'),
  MFA: require('@/assets/images/landing-page/MFA.png'),
  doctors: require('@/assets/images/landing-page/doctors.png'),
  satisfaction: require('@/assets/images/landing-page/satisfaction.png'),
  specialities: require('@/assets/images/landing-page/specialities.png'),
  time: require('@/assets/images/landing-page/time.png'),
  upload: require('@/assets/images/landing-page/upload.png'),
  review: require('@/assets/images/landing-page/review.png'),
  AI: require('@/assets/images/landing-page/AI.png'),
  getStarted: require('@/assets/images/landing-page/get_started.png'),
  heroGif: require('@/assets/images/landing-page/hero.gif'),
  default_profile: require('@/assets/images/default-photo.png'),
  payment_success: require('@/assets/images/payment_success.png'),
  payment_failure: require('@/assets/images/payment_failure.png'),
  doc_img: require('@/assets/images/doc_img.png'),
  no_ongoing_consultations: require('@/assets/images/no_ongoing_cons.png'),
  no_ongoing_consultation: require('@/assets/images/no_ongoing_consultaion.png'),
  learnHowItWorks: require('@/assets/images/learnHowItWorks.png'),
  learnHowItWorksResponsive: require('@/assets/images/learnHowItWorksResponsive.png'),
  specialistSampleReferenceLady: require('@/assets/images/Specialist-sample-reference-lady.png'),
  specialistSampleReferenceBg: require('@/assets/images/specialist-sample-reference-bg.png'),
  help: require('@/assets/images/help.png'),
  help_mobile: require('@/assets/images/help_mobile.png'),
} as const;

/**
 * Icons
 */
export const Icons = {
  success: require('@/assets/icons/success.png'),
  failure: require('@/assets/icons/failure.png'),
  settings: require('@/assets/icons/settings.png'),
  settings_white: require('@/assets/icons/settings_white.png'),
  profile_logo: require('@/assets/icons/profile_logo.png'),
  vector_logo: require('@/assets/icons/vector_logo.png'),
  chat: require('@/assets/icons/chat.png'),
  bell: require('@/assets/icons/bell.png'),
  faqs: require('@/assets/icons/faq.png'),
  dashboard: require('@/assets/icons/dashboard.png'),
  support: require('@/assets/icons/support.png'),
  cancel_icon: require('@/assets/icons/cancel_icon.png'),
  support_ticket_white: require('@/assets/icons/support_ticket_white.png'),

  user: require('@/assets/icons/user.png'),
  user_white: require('@/assets/icons/user_white.png'),

  search: require('@/assets/icons/search.png'),

  facebook: require('@/assets/icons/facebook.png'),
  linkedin: require('@/assets/icons/linkedin.png'),
  twitter: require('@/assets/icons/twitter.png'),
  youtube: require('@/assets/icons/youtube.png'),

  arrow_circle_white_left: require('@/assets/icons/arrow_left_circle_white.png'),
  arrow_circle_white_right: require('@/assets/icons/arrow_right_circle_white.png'),
  currency_blue: require('@/assets/icons/currency.png'),

  shield: require('@/assets/icons/shield.png'),
  stethoscope: require('@/assets/icons/stethoscope.png'),
  stethoscope_blue: require('@/assets/icons/stethoscope3.png'),
  analysis: require('@/assets/icons/analysis.png'),

  check_mark: require('@/assets/icons/check-mark.png'),
  Check_circle: require('@/assets/icons/Check_circle.png'),
  mark_all_read: require('@/assets/icons/mark_all_read.png'),
  green_tick_btn: require('@/assets/icons/green_tick_btn.png'),
  cross_btn_red: require('@/assets/icons/cross_btn_red.png'),

  AI: require('@/assets/icons/AI.png'),
  calender_arrow: require('@/assets/icons/calender_arrow.png'),
  calender: require('@/assets/icons/calender.png'),
  download: require('@/assets/icons/download.png'),
  file: require('@/assets/icons/file.png'),
  graduation: require('@/assets/icons/graduation.png'),
  graduation_icon: require('@/assets/icons/graduation_icon.png'),
  lock: require('@/assets/icons/lock.png'),
  dark_lock: require('@/assets/icons/dark_lock.png'),
  roles: require('@/assets/icons/Roles.png'),
  access_modules: require('@/assets/icons/Access_modules.png'),
  shield_blue: require('@/assets/icons/shield_blue.png'),
  time: require('@/assets/icons/time.png'),

  send_white: require('@/assets/icons/send_white.png'),
  send_reply: require('@/assets/icons/send_reply.png'),

  cheveron_down: require('@/assets/icons/cheveron_down.png'),
  cheveron_up: require('@/assets/icons/cheveron_up.png'),
  cheveron_left: require('@/assets/icons/cheveron_left.png'),
  cheveron_right: require('@/assets/icons/cheveron_right.png'),

  dashboard_white: require('@/assets/icons/dashboard_white.png'),
  admins: require('@/assets/icons/admins.png'),
  admins_white: require('@/assets/icons/admins_white.png'),
  access: require('@/assets/icons/access.png'),
  access_white: require('@/assets/icons/access_white.png'),
  audit_log: require('@/assets/icons/audit_log_blue.png'),
  audit_log_blue: require('@/assets/icons/audit_log_blue.png'),
  audit_log_white: require('@/assets/icons/audit_log_white.png'),
  logout: require('@/assets/icons/logout.png'),
  search_blue: require('@/assets/icons/search_blue.png'),
  patient: require('@/assets/icons/patient.png'),

  close: require('@/assets/icons/close.png'),
  arrow_up_circle_white: require('@/assets/icons/arrow_up_circle_white.png'),

  activity: require('@/assets/icons/activity.png'),
  activity_white: require('@/assets/icons/activity_white.png'),

  consultation_white: require('@/assets/icons/consultation_white.png'),
  consultation: require('@/assets/icons/consultation.png'),

  help: require('@/assets/icons/help.png'),
  help_white: require('@/assets/icons/help_white.png'),
  exclametory_mark: require('@/assets/icons/exclametory_mark.png'),
  emergency_contact: require('@/assets/icons/emergency_contact.png'),
  help_p_1: require('@/assets/icons/help_p_1.png'),
  help_p_2: require('@/assets/icons/help_p_2.png'),
  help_p_3: require('@/assets/icons/help_p_3.png'),
  help_onboarding: require('@/assets/icons/help_onboarding.png'),
  help_consultations: require('@/assets/icons/help_consultations.png'),
  help_second_opinion: require('@/assets/icons/help_second_opinion.png'),
  help_payments: require('@/assets/icons/help_payments.png'),

  specialist: require('@/assets/icons/specialist.png'),
  specialist_white: require('@/assets/icons/specialist_white.png'),

  arrow_black: require('@/assets/icons/arrow-black.png'),
  star: require('@/assets/icons/star.png'),

  reload: require('@/assets/icons/reload.png'),
  star_grey: require('@/assets/icons/star_grey.png'),

  //icons for patient dashboard
  circle_arrow_up: require('@/assets/icons/circle-arrow-up.png'),
  circle_arrow_down: require('@/assets/icons/circle-arrow-down.png'),
  circle_1: require('@/assets/icons/circle_1.png'),
  circle_2: require('@/assets/icons/circle_2.png'),
  circle_3: require('@/assets/icons/circle_3.png'),
  circle_4: require('@/assets/icons/circle_4.png'),
  upload_report: require('@/assets/icons/upload_report.png'),
  trash_red: require('@/assets/icons/trash_red.png'),
  menu: require('@/assets/icons/menu.png'),
  success_2: require('@/assets/icons/success_2.png'),
  warning: require('@/assets/icons/warning.png'),
  warning_setting: require('@/assets/icons/warning_setting.png'),
  yellow_warning: require('@/assets/icons/yellow_warning.png'),
  await: require('@/assets/icons/await.png'),

  //icons for specilist card
  education_cap: require('@/assets/icons/education_cap.png'),
  location: require('@/assets/icons/location.png'),
  star_yellow: require('@/assets/icons/star_yellow.png'),
  pin: require('@/assets/icons/pin.png'),
  phone: require('@/assets/icons/phone.png'),
  medical: require('@/assets/icons/medical.png'),
  height: require('@/assets/icons/height.png'),
  gender: require('@/assets/icons/gender.png'),
  email: require('@/assets/icons/email.png'),
  email_clear: require('@/assets/icons/email_clear.png'),
  weight: require('@/assets/icons/weight.png'),

  //icons for consultation screen
  view_details: require('@/assets/icons/view_details.png'),
  download_btn: require('@/assets/icons/download_btn.png'),
  file_arrow_up: require('@/assets/icons/file_arrow_up.png'),
  message: require('@/assets/icons/message.png'),

  //icons for specialist consultation screen
  ai_icon: require('@/assets/icons/ai_icon.png'),
  edit_input: require('@/assets/icons/edit_input.png'),
  upload_up: require('@/assets/icons/upload_up.png'),
  download_icon: require('@/assets/icons/download_icon.png'),
  file_attach: require('@/assets/icons/attach_file.png'),
  download_btn_nobg: require('@/assets/icons/download_btn_nobg.png'),
  white_download_btn: require('@/assets/icons/white_download_btn.png'),

  patient2: require('@/assets/icons/patient2.png'),
  patient2_white: require('@/assets/icons/patient2_white.png'),
  cash_white: require('@/assets/icons/cash_white.png'),
  cash: require('@/assets/icons/cash.png'),
  feedback: require('@/assets/icons/feedback.png'),
  feedback_white: require('@/assets/icons/feedback_white.png'),
  calender2: require('@/assets/icons/calender2.png'),

  diagnosis: require('@/assets/icons/diagnosis.png'),
  star_big: require('@/assets/icons/star_big.png'),
  medical_record: require('@/assets/icons/medical_record.png'),
  awards_logo: require('@/assets/icons/awards.png'),
  yellow_award_icon: require('@/assets/icons/Yellow_Award_Icon.png'),
  expertise_logo: require('@/assets/icons/expertise.png'),

  calender_clock: require('@/assets/icons/calender_clock.png'),
  user2: require('@/assets/icons/user2.png'),
  hourglass: require('@/assets/icons/hourglass.png'),

  recent_user: require('@/assets/icons/recent_user.png'),
  goto: require('@/assets/icons/goto.png'),
  happy_heart: require('@/assets/icons/happy_heart.png'),
  sort: require('@/assets/icons/sort.png'),

  arrow_left: require('@/assets/icons/arrow_left.png'),
  Left_arrow: require('@/assets/icons/Left_arrow.png'),
  right_arrow: require('@/assets/icons/right_arrow.png'),
  home_plus: require('@/assets/icons/home_plus.png'),
  plus_white: require('@/assets/icons/plus_white.png'),
  stethoscope2: require('@/assets/icons/stethoscope2.png'),

  box_search: require('@/assets/icons/box_search.png'),
  calender_green: require('@/assets/icons/calender_green.png'),

  link: require('@/assets/icons/link.png'),
  business_center_logo: require('@/assets/icons/business_center_logo.png'),
  patient_feedback_icon: require('@/assets/icons/patient-feedback_icon.png'),
  double_quote_icon: require('@/assets/icons/double_quote_icon.png'),
  feedback_star: require('@/assets/icons/feedback_star.png'),

  close_white: require('@/assets/icons/close_white.png'),
  send: require('@/assets/icons/send.png'),

  recommended_steps: require('@/assets/icons/recommended_steps.png'),

  specialist_display_blue: require('@/assets/icons/Specialist_display_blue.png'),
  specialist_display_white: require('@/assets/icons/Specialist_display_white.png'),
  display_setting_blue: require('@/assets/icons/Patient_setting_blue.png'),
  display_setting_white: require('@/assets/icons/Patient_setting_white.png'),
  infinity: require('@/assets/icons/infinity.png'),
  management_setting: require('@/assets/icons/Account_management_settings.png'),
  compliance: require('@/assets/icons/compliance.png'),
  system: require('@/assets/icons/system.png'),

  hospital: require('@/assets/icons/hospital.png'),
  hospital_white: require('@/assets/icons/hospital_white.png'),

  home_info: require('@/assets/icons/home_info.png'),
  certification: require('@/assets/icons/certification.png'),
  tick: require('@/assets/icons/tick.png'),
  edit: require('@/assets/icons/edit.png'),
  box_question: require('@/assets/icons/box_question.png'),
  folder: require('@/assets/icons/folder.png'),

  cash_blue2: require('@/assets/icons/cash_blue2.png'),
  location_blue: require('@/assets/icons/location_blue.png'),
  phone_blue: require('@/assets/icons/phone_blue.png'),
  email_blue: require('@/assets/icons/email_blue.png'),
  request_summary: require('@/assets/icons/request_summary.png'),
  eye: require('@/assets/icons/eye.png'),
  consultaion_fee: require('@/assets/icons/consultaion_fee.png'),
  change_request: require('@/assets/icons/change_request.png'),
  file_blue: require('@/assets/icons/file_blue.png'),
  white_patient_payment: require('@/assets/icons/white_patient_payment.png'),
  blue_specialist_payouts: require('@/assets/icons/blue_specialist_payouts.png'),

  assign_specialist: require('@/assets/icons/assign_specialist.png'),
  select_specialist: require('@/assets/icons/select_specialist.png'),
  select_specialist_model: require('@/assets/icons/select_specialist_model.png'),

  file_info: require('@/assets/icons/file-info.png'),
  i_icon: require('@/assets/icons/i-icon.png'),
  danger: require('@/assets/icons/danger.png'),

  file_arrow_up_blue: require('@/assets/icons/file_arrow_up_blue.png'),
  hospital_colorful: require('@/assets/icons/hospital_colorful.png'),
  hospital_specialist: require('@/assets/icons/hospital_specialist.png'),

  signature: require('@/assets/icons/signature.png'),
  orange_clock: require('@/assets/icons/orange_clock.png'),

  request_document: require('@/assets/icons/request_document.png'),
  request_document_white: require('@/assets/icons/request_document_white.png'),

  file_arrow_up_white: require('@/assets/icons/file_arrow_up_white.png'),

  admin_oversight: require('@/assets/icons/admin_oversight.png'),
  audit_logging: require('@/assets/icons/audit_logging.png'),

  mic: require('@/assets/icons/mic.png'),
  close_mic: require('@/assets/icons/close_mic.png'),
  check: require('@/assets/icons/check.png'),

  heart_empty: require('@/assets/icons/heart_empty.png'),
  heart_red: require('@/assets/icons/heart_red.png'),

  previous_case_file: require('@/assets/icons/previous_case_file.png'),
} as const;

export const videos = {
  ai_summary_gif: require('@/assets/gif/ai_summary.mp4'),
};

/**
 * header links
 */
export const headerLinks = [
  {label: 'Home', link: Routes.INDEX + '#home'},
  {label: 'About', link: Routes.INDEX + '#about'},
  {label: 'Doctors', link: Routes.INDEX + '#doctor'},
  {label: 'Services', link: Routes.INDEX + '#service'},
  {label: 'Contact', link: Routes.INDEX + '#contact'},
] as const;

/**
 * landing page content
 */
export const LandingPageContent = {
  hero: {
    header: {
      links: headerLinks,
      cta: [
        {
          label: 'Log In',
          link: Routes.LOGIN,
          variant: 'primary',
        },
        {
          label: 'Get Started',
          link: Routes.SIGNUP,
          variant: 'primary',
        },
      ],
    },
    body: {
      features: [
        {icon: 'shield', title: 'HIPAA Compliant'},
        {icon: 'analysis', title: 'AI-Powered Analysis'},
        {icon: 'stethoscope', title: 'Expert Doctors'},
      ],
      main: 'Get a Trusted Second Opinion On Your Medical Reports',
      sub: 'Upload your medical reports, get AI-Powered analysis, and receive expert review from specialist doctors. Make informed decisions about your health with confidence.',
    },
    medical_reports: {
      title: 'Medical Report Analysis',
      steps: [
        {
          image: Images.AI,
          title: 'AI Analysis Complete',
          summary: 'Your report has been analyzed and summarized',
        },
        {
          image: Images.review,
          title: 'Doctor Review',
          summary: 'Specialist review in progress',
        },
      ],
      gif: Images.heroGif,
    },
  },
  explanation: {
    title: [
      {
        text: 'How',
        is_special: false,
      },
      {
        text: 'Heal',
        is_special: true,
      },
      {
        text: 'Works',
        is_special: false,
      },
    ],
    description: 'Get expert second opinions in three simple steps. Our streamlined process\ncombines cutting-edge AI with experienced doctors',
    steps: [
      {
        image: Images.upload,
        title: 'Upload Your Report',
        description: 'Securely upload your medical report, lab results, or imaging studies. Our platform supports all major formats.',
      },
      {
        image: Images.AI,
        title: 'AI Analysis',
        description: 'Advanced AI analyzes your reports and creates a comprehensive summary highlighting key findings and concerns',
      },
      {
        image: Images.review,
        title: 'Doctor Review',
        description: 'A specialist doctor reviews the AI summary and your original reports to provide expert medical insights',
      },
    ],

    getStarted: {
      title: [
        {
          text: 'Ready',
          is_special: false,
        },
        {
          text: 'to get',
          is_special: true,
        },
        {
          text: 'started?',
          is_special: false,
        },
      ],
      description: 'Join thousands of patients who HEAL for reliable second opinions on their medical reports',
      ctaText: 'Upload Your First Report',
    },
  },
  stats: [
    {
      image: Images.time,
      stat: '48 hrs',
      label: 'Response Time',
    },
    {
      image: Images.satisfaction,
      stat: '95%',
      label: 'Patient Satisfaction',
    },
    {
      image: Images.doctors,
      stat: '500+',
      label: 'Specialist Doctors',
    },
    {
      image: Images.specialities,
      stat: '50+',
      label: 'Medical Specialties',
    },
  ],
  security: {
    title: 'Built on Trust & Security',
    card: [
      [
        {
          image: Images.board_certified,
          title: 'Board Certified\nDoctors',
          description: 'Our network includes only licensed, board-certified specialists',
        },
      ],
      [
        {
          image: Images.hippa_complaince,
          title: 'HIPAA Compliant',
          description: 'Your medical data is protected with industry-leading security standards',
        },

        {
          image: Images.end_to_end_encryption,
          title: 'End-to-End\nEncryption',
          description: 'All data transmission and storage uses advanced encryption protocols',
        },
      ],
      [
        {
          image: Images.patients_trusted,
          title: '10,000+ Patients\nServed',
          description: 'Trusted by patients for secure, high-quality, and reliable care',
        },
      ],
    ],
  },
  doctors: {
    title: 'Our Expert Doctors',
    doctors: [
      {
        photo: Images.doctor_4,
        name: 'Dr. Santosh Kumar',
        description: 'Board-certified in both Internal and Lifestyle Medicine, Dr. Santosh Kumar is a passionate advocate for holistic health.',
      },
      {
        photo: Images.doctor_3,
        name: 'Dr. Sara Mirza, MD',
        description: 'A board-certified neurosurgeon renowned for his pioneering work in endoscopic techniques and health',
      },
      {
        photo: Images.doctor_2,
        name: 'Dr. Aravind Nair ',
        description: 'Board-certified in both Internal and Lifestyle Medicine, Dr. Aravind Nair is a passionate advocate for holistic health. ',
      },
    ],
  },
  about: {
    title: 'About Portals',
    cards: [
      {
        title: 'For Patients',
        points: [
          {
            icon: 'file',
            text: 'Upload reports in any format (PDF, images, etc.)',
          },
          {
            icon: 'AI',
            text: 'Receive AI-powered preliminary analysis',
          },
          {
            icon: 'time',
            text: 'Get specialist doctor review within 48 hours',
          },
          {
            icon: 'download',
            text: 'Access your reports and reviews anytime',
          },
          {
            icon: 'lock',
            text: 'Secure messaging with healthcare providers',
          },
        ],
      },
      {
        title: 'For Doctors',
        points: [
          {
            icon: 'search',
            text: 'Access to AI-summarized patient reports',
          },
          {
            icon: 'calender2',
            text: 'Flexible scheduling and workload management',
          },
          {
            icon: 'calender_arrow',
            text: 'Secure platform for patient communication',
          },
          {
            icon: 'graduation',
            text: 'Professional development opportunities',
          },
          {
            icon: 'stethoscope_blue',
            text: 'Easy doctor-to-doctor referrals available',
          },
        ],
      },
    ],
  },
  footer: {
    quick_links: [
      {
        title: 'Quick Links',
        links: [
          {label: 'Contact Us', link: Routes.INDEX + '#contact'},
          {label: 'How it works', link: Routes.INDEX + '#service'},
          {label: 'For patients', link: Routes.INDEX + '#about'},
          {label: 'For Doctors', link: Routes.INDEX + '#about'},
          {label: 'Security Policy', link: Routes.PRIVACY},
          {label: 'Terms & Conditions', link: Routes.TERMS},
        ],
      },
      // {
      //   title: 'Support',
      //   links: [
      //     {label: 'Help Center', link: '#'},
      //     {label: 'Contact Support', link: '#'},
      //     {label: 'Doctor Resources', link: '#'},
      //     {label: 'Report Policy', link: '#'},
      //     {label: 'Return Policy', link: '#'},
      //     {label: 'Refund Policy', link: '#'},
      //   ],
      // },
    ],
    social_media: {
      title: 'Second Opinion',
      description: 'Empowering patients with trusted medical second opinions through AI-powered analysis and expert doctor reviews.',
      links: [
        {icon: 'facebook', link: 'https://www.facebook.com/share/16kT2aCcM4/'},
        {icon: 'linkedin', link: 'https://www.linkedin.com/company/infoforte'},
        {icon: 'youtube', link: 'https://youtube.com/@heal2709?si=akQUpNFUBcrOdje-'},
      ],
    },
    bottom: [
      {label: 'Security Policy', link: Routes.PRIVACY},
      {label: 'Terms & Conditions', link: Routes.TERMS},
    ],
  },
} as const;

//==============================================//
// Enums labels
//==============================================//
export const ConsultationStatusLabels: Record<ConsultationStatus, string> = {
  [ConsultationStatus.AwaitingDoctorReview]: 'Awaiting Doctor Review',
  [ConsultationStatus.UnderReviewByDoctor]: 'Under Review By Doctor',
  [ConsultationStatus.DoctorChatActive]: 'Doctor Chat Active',
  [ConsultationStatus.ReportReady]: 'Report Ready',
  [ConsultationStatus.Completed]: 'Completed',
  [ConsultationStatus.FollowUpEligible]: 'Follow Up Eligible',
  [ConsultationStatus.FollowUpExpired]: 'Follow Up Expired',
  [ConsultationStatus.ReferredInternal]: 'Referred Internal',
  [ConsultationStatus.ReferredExternal]: 'Referred External',
  [ConsultationStatus.CancelledByPatient]: 'Cancelled',
  [ConsultationStatus.Overdue]: 'Overdue',
  [ConsultationStatus.SpecialistAllocationPending]: 'Awaiting Doctor Assignment',
};

export const SpecialistConsultationStatusLabels: Record<ConsultationStatus, string> = {
  ...ConsultationStatusLabels,
  [ConsultationStatus.AwaitingDoctorReview]: 'Awaiting Review',
  [ConsultationStatus.ReportReady]: 'Report Submitted',
  [ConsultationStatus.UnderReviewByDoctor]: 'Under Review',
};

export const ConsultationTypeLabels: Record<ConsultationType, string> = {
  [ConsultationType['Online Second Opinion']]: 'Online Second Opinion',
  [ConsultationType['Follow Up Second Opinion']]: 'Follow Up Second Opinion',
  [ConsultationType['Referral Second Opinion']]: 'Referral Second Opinion',
  [ConsultationType['Hospital Follow Up Second Opinion']]: 'Hospital Follow Up Second Opinion',
  [ConsultationType['Hospital Referral Second Opinion']]: 'Hospital Referral Second Opinion',
};

export const HelpRequestStatusLabels: Record<HelpRequestStatus, string> = {
  [HelpRequestStatus.Open]: 'Open',
  [HelpRequestStatus.Closed]: 'Closed',
  [HelpRequestStatus.Spam]: 'Spam',
};

export const HelpRequestUserTypeLabels: Record<HelpRequestUserType, string> = {
  [HelpRequestUserType.Patient]: 'Patient',
  [HelpRequestUserType.Specialist]: 'Specialist',
  [HelpRequestUserType.Visitor]: 'Visitor',
  [HelpRequestUserType.HospitalPoc]: 'Hospital POC',
};

export const HospitalTypeLabel: Record<HospitalType, string> = {
  [HospitalType.MultispecialityHospital]: 'Multi-Speciality Hospital',
  [HospitalType.SuperspecialityHospital]: 'Super-Speciality Hospital',
  [HospitalType.SpecialityHospital]: 'Speciality Hospital',
  [HospitalType.DaignosticCenter]: 'Daignostic Center',
  [HospitalType.Polyclinic]: 'Polyclinic',
};

export const HospitalSpecialistOnboardingStatusLabels: Record<HospitalSpecialistOnboardingStatus, string> = {
  [HospitalSpecialistOnboardingStatus.Invited]: 'Invite Sent',
  [HospitalSpecialistOnboardingStatus.Registered]: 'Registered',
  [HospitalSpecialistOnboardingStatus.Active]: 'Active',
};

export const PatientAccountTicketRequestStatusLabels: Record<PatientAccountTicketRequestStatus, string> = {
  [PatientAccountTicketRequestStatus.NotApplicable]: 'Not Applicable',
  [PatientAccountTicketRequestStatus.Requested]: 'Requested',
  [PatientAccountTicketRequestStatus.Exported]: 'Exported',
  [PatientAccountTicketRequestStatus.Pending]: 'Pending',
  [PatientAccountTicketRequestStatus.Approved]: 'Approved',
  [PatientAccountTicketRequestStatus.Paused]: 'Paused',
  [PatientAccountTicketRequestStatus.Resumed]: 'Resumed',
  [PatientAccountTicketRequestStatus.Deleted]: 'Deleted',
  [PatientAccountTicketRequestStatus.Cancelled]: 'Cancelled',
};

export const PatientAccountRequestRequestTypeLabels: Record<PatientAccountTicketType, string> = {
  [PatientAccountTicketType.ExportOnly]: 'Export Only',
  [PatientAccountTicketType.ExportDelete]: 'Export + Delete',
};

//==============================================//
// enums to status badge variants
//==============================================//
export const HospitalSpecialistOnboardingStatusBadgeVariants: Record<HospitalSpecialistOnboardingStatus, StatusBadgeVariant> = {
  [HospitalSpecialistOnboardingStatus.Invited]: StatusBadgeVariant.DARK_BLUE,
  [HospitalSpecialistOnboardingStatus.Registered]: StatusBadgeVariant.GREY,
  [HospitalSpecialistOnboardingStatus.Active]: StatusBadgeVariant.GREEN,
};

export const HelpRequestStatusBadgeVariants: Record<HelpRequestStatus, StatusBadgeVariant> = {
  [HelpRequestStatus.Open]: StatusBadgeVariant.GREEN,
  [HelpRequestStatus.Closed]: StatusBadgeVariant.GREY,
  [HelpRequestStatus.Spam]: StatusBadgeVariant.RED,
};

export const PatientAccountTicketRequestStatusBadgeVariants: Record<PatientAccountTicketRequestStatus, StatusBadgeVariant> = {
  [PatientAccountTicketRequestStatus.NotApplicable]: StatusBadgeVariant.GREY,
  [PatientAccountTicketRequestStatus.Requested]: StatusBadgeVariant.FADE_BLUE,
  [PatientAccountTicketRequestStatus.Exported]: StatusBadgeVariant.LIGHT_GREEN,
  [PatientAccountTicketRequestStatus.Pending]: StatusBadgeVariant.FADE_ORANGE,
  [PatientAccountTicketRequestStatus.Approved]: StatusBadgeVariant.GREEN,
  [PatientAccountTicketRequestStatus.Paused]: StatusBadgeVariant.RED,
  [PatientAccountTicketRequestStatus.Resumed]: StatusBadgeVariant.PEARL_BLUE,
  [PatientAccountTicketRequestStatus.Deleted]: StatusBadgeVariant.DARK_GRAY,
  [PatientAccountTicketRequestStatus.Cancelled]: StatusBadgeVariant.DARK_ORANGE,
};

export const ConsultationStatusBadgeVariants = {
  [ConsultationStatus.AwaitingDoctorReview]: StatusBadgeVariant.YELLOW,
  [ConsultationStatus.UnderReviewByDoctor]: StatusBadgeVariant.ORANGE,
  [ConsultationStatus.Completed]: StatusBadgeVariant.GREEN,
  [ConsultationStatus.CancelledByPatient]: StatusBadgeVariant.RED,
  [ConsultationStatus.ReportReady]: StatusBadgeVariant.GREEN,

  [ConsultationStatus.DoctorChatActive]: StatusBadgeVariant.GREEN,
  [ConsultationStatus.FollowUpExpired]: StatusBadgeVariant.GREEN,
  [ConsultationStatus.ReferredExternal]: StatusBadgeVariant.GREEN,
  [ConsultationStatus.ReferredInternal]: StatusBadgeVariant.GREEN,
  [ConsultationStatus.FollowUpEligible]: StatusBadgeVariant.GREEN,
  [ConsultationStatus.Overdue]: StatusBadgeVariant.GREEN,
  [ConsultationStatus.SpecialistAllocationPending]: StatusBadgeVariant.LIGHT_BLUE,
};

export const SpeclaistConsultationStatusBadgeVariants = {
  ...ConsultationStatusBadgeVariants,
  [ConsultationStatus.AwaitingDoctorReview]: StatusBadgeVariant.ORANGE_LIGHT,
  [ConsultationStatus.UnderReviewByDoctor]: StatusBadgeVariant.BLUE,
  [ConsultationStatus.Overdue]: StatusBadgeVariant.GREY,
};

// Specialist Admin Onboarding Status
export const SpecialistAdminOnboardingStatusLabels: Record<SpecialistOnboardingStatus, string> = {
  [SpecialistOnboardingStatus.Incomplete]: 'Incomplete',
  [SpecialistOnboardingStatus.UnderReview]: 'Under Review',
  [SpecialistOnboardingStatus.ChangesRequested]: 'Changes Required',
  [SpecialistOnboardingStatus.Approved]: 'Approved',
  [SpecialistOnboardingStatus.ProfileEdited]: 'Profile Edited',
};

export const HospitalSpecialistAssignmentStatusLabels: Record<HospitalSpecialistAssignmentStatus, string> = {
  [HospitalSpecialistAssignmentStatus.Pending]: 'Pending',
  [HospitalSpecialistAssignmentStatus.Assigned]: 'Assigned',
  [HospitalSpecialistAssignmentStatus.Cancelled]: 'Cancelled',
};

export const SpecialistAdminOnboardingStatusBadgeVariants: Record<SpecialistOnboardingStatus, StatusBadgeVariant> = {
  [SpecialistOnboardingStatus.Incomplete]: StatusBadgeVariant.FADE_BLUE,
  [SpecialistOnboardingStatus.UnderReview]: StatusBadgeVariant.PEARL_BLUE,
  [SpecialistOnboardingStatus.ChangesRequested]: StatusBadgeVariant.RED,
  [SpecialistOnboardingStatus.Approved]: StatusBadgeVariant.GREEN,
  [SpecialistOnboardingStatus.ProfileEdited]: StatusBadgeVariant.PEARL_BLUE,
};

//==============================================//
// Sort Option Labels
//==============================================//
export const SortOptionLabels: Record<SortOption, string> = {
  [SortOption.DESC]: 'Newest -> Oldest',
  [SortOption.ASC]: 'Oldest -> Newest',
};

export const statusOptions: SelectInputitem[] = [
  {id: 1, label: 'Active'},
  {id: 2, label: 'Blocked'},
];

export const ProgressBarStepLabelMap: Record<ProgressBarSteps, string> = {
  [ProgressBarSteps.NotStarted]: 'Not Started',
  [ProgressBarSteps.CaseAnalysisStarted]: 'Case Analysis Started',
  [ProgressBarSteps.DocumentSent]: 'Document Sent',
  [ProgressBarSteps.DocomentAnalysisStarted]: 'Document Analysis Started',
  [ProgressBarSteps.DocomentAnalysisCompleted]: 'Document Analysis Completed',
  [ProgressBarSteps.SpecialistFetched]: 'Specialist Fetched',
  [ProgressBarSteps.ConsultationCaseUpdated]: 'Consultation Case Updated',
  [ProgressBarSteps.Complete]: 'Complete',
};

export const UploadAdditionalFilesProgressBarStepLabelMap: Record<UploadAdditionalFilesProgressBarSteps, string> = {
  [UploadAdditionalFilesProgressBarSteps.NotStarted]: 'Not Started',
  [UploadAdditionalFilesProgressBarSteps.DocumentSent]: 'Document Sent',
  [UploadAdditionalFilesProgressBarSteps.ValidatingFiles]: 'Validating Files',
  [UploadAdditionalFilesProgressBarSteps.CheckingForDuplicates]: 'Checking for Duplicates',
  [UploadAdditionalFilesProgressBarSteps.UpdatingCaseSummary]: 'Updating Case Summary',
  [UploadAdditionalFilesProgressBarSteps.Complete]: 'Complete',
};

export const ResourceTypeLabels: Record<ResourceType, string> = {
  [ResourceType.User]: 'User',
  [ResourceType.ConsultationCase]: 'Consultation Case',
  [ResourceType.Message]: 'Message',
  [ResourceType.Referral]: 'Referral',
  [ResourceType.Document]: 'Document',
  [ResourceType.Payment]: 'Payment',
  [ResourceType.Feedback]: 'Feedback',
  [ResourceType.Notification]: 'Notification',
  [ResourceType.AccountDeletionTicket]: 'Account Deletion Ticket',
  [ResourceType.SpecialistProfileChangeRequest]: 'Specialist Profile Change Request',
  [ResourceType.UserQueryTicket]: 'User Query Ticket',
  [ResourceType.FilterOption]: 'Filter Option',
  [ResourceType.Category]: 'Category',
  [ResourceType.AccountExportTicket]: 'Account Export Ticket',
  [ResourceType.ConsultationSummary]: 'Consultation Summary',
  [ResourceType.SpecialistInvitation]: 'Specialist Invitation',
  [ResourceType.PopularityLimit]: 'Popularity Limit',
  [ResourceType.AdminRole]: 'Admin Role',
  [ResourceType.LicenseVerificationMode]: 'License Verification Mode',
  [ResourceType.Favourite]: 'Favourite',
};

export const ActionTypeLabels: Record<ActionType, string> = {
  [ActionType.Created]: 'Created',
  [ActionType.Updated]: 'Updated',
  [ActionType.Deleted]: 'Deleted',
  [ActionType.Login]: 'Login',
  [ActionType.View]: 'View',
  [ActionType.Signup]: 'Signup',
  [ActionType.Selected]: 'Selected',
  [ActionType.Cancelled]: 'Cancelled',
  [ActionType.Assigned]: 'Assigned',
  [ActionType.Activated]: 'Activated',
  [ActionType.Deactivated]: 'Deactivated',
  [ActionType.Logout]: 'Logout',
  [ActionType.Requested]: 'Requested',
};

export const UserRoleLabels: Record<UserRole, string> = {
  [UserRole.SUPER_ADMIN]: 'Super Admin',
  [UserRole.PATIENT]: 'Patient',
  [UserRole.SPECIALIST]: 'Specialist',
  [UserRole.HOSPITAL_POC]: 'Hospital POC',
  [UserRole.ADMIN]: 'Admin',
};

export const HospitalSpecialistAssignmentStatusBadgeVariants: Record<HospitalSpecialistAssignmentStatus, StatusBadgeVariant> = {
  [HospitalSpecialistAssignmentStatus.Pending]: StatusBadgeVariant.YELLOW,
  [HospitalSpecialistAssignmentStatus.Assigned]: StatusBadgeVariant.GREEN,
  [HospitalSpecialistAssignmentStatus.Cancelled]: StatusBadgeVariant.RED,
};

export const SpecialistProfileToOnboardingStatusMapping = {
  [SpecialistProfileStatus.NotStarted]: SpecialistOnboardingStatus.Incomplete,
  [SpecialistProfileStatus.Pending]: SpecialistOnboardingStatus.Incomplete,
  [SpecialistProfileStatus.EligibleForApproval]: SpecialistOnboardingStatus.Incomplete,
  [SpecialistProfileStatus.AwaitingAdminApproval]: SpecialistOnboardingStatus.UnderReview,
  [SpecialistProfileStatus.ChangeRequested]: SpecialistOnboardingStatus.ChangesRequested,
  [SpecialistProfileStatus.Approved]: SpecialistOnboardingStatus.Approved,
  [SpecialistProfileStatus.ReSubmitted]: SpecialistOnboardingStatus.ProfileEdited,
  [SpecialistProfileStatus.ProfileEdited]: SpecialistOnboardingStatus.Approved,
  [SpecialistProfileStatus.ReChangeRequested]: SpecialistOnboardingStatus.ChangesRequested,
  [SpecialistProfileStatus.ReEditAfterReChangeRequested]: SpecialistOnboardingStatus.ChangesRequested,
};

//==============================================//
// Terms and Conditions Content
//==============================================//
export const TermsAndConditionsData = {
  lastUpdated: '04 Feburary 2026',
  sections: [
    {
      title: '1. Definitions',
      content: {
        intro:
          'For the purposes of these Terms & Conditions, unless the context otherwise requires, the following terms shall have the meanings assigned below:',
        items: [
          {
            number: '1.1',
            term: '"Platform"',
            description: 'means the HEAL Second Opinion digital platform, including its website, applications, software, and related services.',
          },
          {
            number: '1.2',
            term: '"HEAL", "Company", "we", "us", or "our"',
            description: 'refers to HEAL and its affiliates, owners, directors, officers, employees, and authorized agents.',
          },
          {
            number: '1.3',
            term: '"User"',
            description: 'means any individual or entity accessing or using the Platform, including Patients and Medical Specialists.',
          },
          {
            number: '1.4',
            term: '"Patient"',
            description: 'means a User who submits medical information on the Platform for the purpose of obtaining a medical second opinion.',
          },
          {
            number: '1.5',
            term: '"Medical Specialist" or "Specialist"',
            description: 'means a licensed medical professional registered on the Platform to provide medical second opinions.',
          },
          {
            number: '1.6',
            term: '"Medical Information"',
            description:
              'means any health-related data, medical records, reports, images, test results, or personal health information submitted to the Platform.',
          },
          {
            number: '1.7',
            term: '"Second Opinion"',
            description:
              'means a professional medical opinion provided by a Medical Specialist based solely on the Medical Information submitted by a Patient.',
          },
          {
            number: '1.8',
            term: '"AI Tools"',
            description: 'means any artificial intelligence or automated systems used by the Platform for summarization, analysis, or workflow support.',
          },
          {
            number: '1.9',
            term: '"Applicable Laws"',
            description: 'means all applicable local, national, and international laws, regulations, medical guidelines, and data protection statutes.',
          },
        ],
      },
      type: 'intro-list' as const,
    },
    {
      title: '2. Acceptance of Terms',
      content:
        'By accessing, registering for, or using the Platform, the User confirms that they have read, understood, and agreed to be bound by these Terms & Conditions ("Terms") and all Applicable Laws. If the User does not agree with these Terms, they must immediately discontinue use of the Platform.',
      type: 'text' as const,
    },
    {
      title: '3. Scope of Services',
      content: [
        {
          number: '3.1',
          description:
            'The Platform facilitates access to medical second-opinion services by enabling Patients to securely share Medical Information with Medical Specialists.',
        },
        {number: '3.2', description: 'The Platform may provide AI-assisted summaries or organizational tools for informational and operational purposes only.'},
        {number: '3.3', description: 'The Platform does not provide direct medical treatment, diagnosis, prescriptions, or emergency medical services.'},
      ],
      type: 'list' as const,
    },
    {
      title: '4. Medical Disclaimer & No Emergency Use',
      content: [
        {
          number: '4.1',
          description:
            'All Second Opinions provided through the Platform are advisory in nature and are intended to supplement, not replace, consultation with a primary treating physician.',
        },
        {number: '4.2', description: 'Use of the Platform does not establish a doctor–patient relationship between the Patient and HEAL.'},
        {
          number: '4.3',
          description:
            'The Platform must not be used for medical emergencies. In the event of an emergency, Users must seek immediate in-person medical care or contact local emergency services.',
        },
      ],
      type: 'list' as const,
    },
    {
      title: '5. AI Usage Disclaimer',
      content: [
        {number: '5.1', description: 'AI Tools are used solely to assist with data processing, summarization, and workflow efficiency.'},
        {number: '5.2', description: 'AI Tools do not provide medical advice, diagnosis, or treatment.'},
        {number: '5.3', description: 'HEAL makes no representations or warranties regarding the accuracy or completeness of AI-generated outputs.'},
      ],
      type: 'list' as const,
    },
    {
      title: '6. Eligibility and User Obligations',
      content: [
        {
          number: '6.1',
          description:
            'Patient Obligations:\nPatients agree to: Provide accurate, complete, and current Medical Information - Use the Platform only for lawful, non-emergency purposes - Acknowledge that Second Opinions are based solely on submitted information',
        },
        {
          number: '6.2',
          description:
            'Specialist Obligations:\nMedical Specialists agree to: Maintain valid and active medical licenses - Comply with professional, ethical, and regulatory obligations - Provide opinions in good faith and within agreed service timelines',
        },
      ],
      type: 'list' as const,
    },
    {
      title: '7. Payments and Fees',
      content: [
        {number: '7.1', description: 'Fees for services shall be disclosed prior to purchase.'},
        {number: '7.2', description: 'Payments are processed through third-party payment processors.'},
        {number: '7.3', description: 'Refunds, if any, shall be governed by the Platform’s refund policy. ated outputs'},
        {number: '7.4', description: 'HEAL is not responsible for payment failures or delays caused by third-party providers. '},
      ],
      type: 'list' as const,
    },
    {
      title: '8. Consent to Data Processing',
      content:
        'By using the Platform, Patients expressly consent to the collection, processing, storage, and sharing of Medical Information for the purpose of providing Second Opinions, complying with legal obligations, and improving service quality.',
      type: 'text' as const,
    },
    {
      title: '9. Data Security, Privacy & Retention',
      content: [
        {number: '9.1', description: 'HEAL implements reasonable administrative, technical, and physical safeguards to protect data.'},
        {number: '9.2', description: 'Despite best efforts, absolute data security cannot be guaranteed.'},
        {number: '9.3', description: 'Data shall be retained only for as long as required to provide services and comply with Applicable Laws.'},
      ],
      type: 'list' as const,
    },
    {
      title: '10. Confidentiality',
      content:
        'All Users shall maintain strict confidentiality of any Medical Information accessed through the Platform. Unauthorized disclosure may result in immediate termination and legal action.',
      type: 'text' as const,
    },
    {
      title: '11. Intellectual Property Rights',
      content:
        'All intellectual property rights in the Platform, including software, content, and trademarks, are owned exclusively by HEAL. No rights are granted except as expressly stated herein.',
      type: 'text' as const,
    },
    {
      title: '12. Third-Party Services',
      content:
        'The Platform may integrate third-party services. HEAL disclaims liability for failures, interruptions, or errors attributable to such third parties.',
      type: 'text' as const,
    },
    {
      title: '13. Suspension and Termination',
      content:
        'HEAL reserves the right to suspend or terminate access to the Platform for violations of these Terms, security concerns, or legal requirements.',
      type: 'text' as const,
    },
    {
      title: '14. Limitation of Liability',
      content:
        'To the maximum extent permitted by law, HEAL shall not be liable for indirect, incidental, or consequential damages. HEAL’s total liability shall not exceed the amount paid by the User for the applicable service.',
      type: 'text' as const,
    },
    {
      title: '15. Indemnification',
      content:
        'Users agree to indemnify and hold harmless HEAL from any claims, losses, or liabilities arising from misuse of the Platform, violation of these Terms, or submission of inaccurate information.',
      type: 'text' as const,
    },
    {
      title: '16. Force Majeure',
      content:
        'HEAL shall not be liable for failure or delay in performance due to events beyond reasonable control, including natural disasters, pandemics, governmental actions, or technical failures.',
      type: 'text' as const,
    },
    {
      title: '17. Governing Law and Jurisdiction',
      content:
        'These Terms shall be governed by and construed in accordance with the laws of India. The courts located at Thiruvananthapuram, Kerala, shall have exclusive jurisdiction over any disputes arising out of or in connection with these Terms.',
      type: 'text' as const,
    },
    {
      title: '18. Amendments',
      content: 'HEAL reserves the right to modify these Terms at any time. Continued use of the Platform constitutes acceptance of revised Terms.',
      type: 'text' as const,
    },
    {
      title: '19. Contact Information',
      content: {
        intro: 'For inquiries related to these Terms:',
        items: [
          'Email: support@healopinion.com',
          'Address: Module No. C1, 3rd Floor, Gayatri Building,\nPhase-I Campus, TECHNOPARK,\nThiruvananthapuram, Kerala, India, 695581',
        ],
      },
      type: 'intro-list' as const,
    },
  ],
} as const;

export const HOME_PAGE_META = {
  base: {
    keywords: [
      'medical second opinion',
      'online medical second opinion',
      'expert medical opinion',
      'AI healthcare platform',
      'specialist consultation',
      'healthcare second opinion',
      'online doctor consultation',
      'medical diagnosis review',
      'virtual healthcare',
      'HEAL Second Opinion',
    ],
    description:
      'HEAL Second Opinion is an AI-powered healthcare platform that connects patients with expert specialists for secure, fast, and reliable medical second opinions.',
    title: 'Heal Second Opinion | Expert Medical Second Opinions Online',
  },
  og: {
    title: 'Heal Second Opinion',
    description: 'Get a Trusted Second Opinion On Your Medical Reports',
    type: 'website',
  },
  twitter: {
    title: 'Heal Second Opinion',
    description: 'Get a Trusted Second Opinion On Your Medical Reports',
    type: 'website',
  },
};
